import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import Slider from "react-slick";
import { RootState } from "../store/store";
import { FilterState, matchesCriterion, sizeImg, Vehicle } from "./VehicleList";
import ORMfunctions from "../hooks/app/general";
import SearchModal from "../components/modals/Searchmodal";
import { setSelectedVehicle } from "../store/orm/userSession";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, A11y } from "swiper/modules";

function Carcategoryslider(props: any) {
  const dispatch = useDispatch();
  const reduxVehicles = useSelector(
    (state: RootState) => state.vehicles.vehicles as Vehicle[],
  );

  const [showModal, setShowModal] = useState(false);
  const [filters, setFilters] = useState<FilterState>({
    categories: [],
    features: {},
  });
  const [enabledstations, setEnabledstations] = useState<string[] | undefined>(
    undefined,
  );

  const filteredVehicles = useMemo(() => {
    const seenCategories = new Set();

    return reduxVehicles.filter((v) => {
      // Kategorie-Filter
      if (
        filters.categories.length > 0 &&
        !filters.categories.some((c) => matchesCriterion(v, "categories", c))
      )
        return false;

      // Feature-Filter
      for (const [name, values] of Object.entries(filters.features)) {
        if (
          values.length > 0 &&
          !values.some((val) => matchesCriterion(v, name, val))
        )
          return false;
      }

      // Nur erstes Fahrzeug pro Kategorie behalten
      const categoryId = v.vehicle_category?.[0]?.id;
      if (seenCategories.has(categoryId) && !props.usevehicles) return false;
      seenCategories.add(categoryId);

      return true;
    });
  }, [reduxVehicles, filters]);

  const allFilterOptions = useMemo(() => {
    const categories = new Set<string>();
    const featureGroups: Record<string, Set<string>> = {};
    reduxVehicles.forEach((v) => {
      v.vehicle_category?.forEach((cat) => cat.id && categories.add(cat.id));
      v.features?.forEach((f) => {
        const name = f.feature?.feature_name;
        if (name && f.value) {
          if (!featureGroups[name]) featureGroups[name] = new Set();
          featureGroups[name].add(f.value);
        }
      });
    });
    return {
      categories: Array.from(categories).sort(),
      features: Object.fromEntries(
        Object.entries(featureGroups).map(([k, v]) => [
          k,
          Array.from(v).sort(),
        ]),
      ),
    };
  }, [reduxVehicles]);

  useEffect(() => {
    if (!props.categorypreselect || !allFilterOptions.categories.length) return;
    if (props.usevehicles) return;

    let categoriesToSelect: string[] = [];

    // Split by '+' (e.g., "kleinwagen+boot+kombi")
    const slugs = props.categorypreselect
      .split("+")
      .map((s: any) => s.trim())
      .filter(Boolean);

    // Match slugs with category IDs
    slugs.forEach((slug: any) => {
      const matched = allFilterOptions.categories.find(
        (catId) => ORMfunctions.slugMe(catId) === slug,
      );
      if (matched) {
        categoriesToSelect.push(matched);
      }
    });

    // Set filters with valid categories
    if (categoriesToSelect.length > 0) {
      setFilters((prev) => ({
        ...prev,
        categories: categoriesToSelect,
      }));
    }
  }, [props.categorypreselect, allFilterOptions.categories]);

  function setCar(cargroup?: Vehicle, useCarCategory?: boolean) {
    if (cargroup) {
      setEnabledstations(cargroup.enabled_stations);
      let categories = filters.categories;
      if (useCarCategory) {
        categories = cargroup!.vehicle_category!.map((item) => item.id);
      }

      dispatch(
        setSelectedVehicle({
          vehicleId: cargroup.id,
          categories: categories,
        }),
      );
    }
    setShowModal(true);
  }

  const settings = {
    dots: true,
    arrows: false,
    fade: false,
    infinite: false,
    speed: 500,
    slidesToShow: props.slidesshown[0] || 4,
    slidesToScroll: 1,
    // initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: props.slidesshown[1] || 3,
          slidesToScroll: props.slidesshown[1] || 3,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: props.slidesshown[2] || 2,
          slidesToScroll: props.slidesshown[2] || 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  // console.log(settings);

  return (
    <div>
      <div className={`orm-carslider`}>
        <Swiper
          pagination={{
            clickable: true,
          }}
          // slidesPerView={props.slidesshown[0] || 4}
          // slidesPerGroup={props.slidesshown[0] || 4}
          spaceBetween={0}
          loop={true}
          modules={[Pagination, A11y]}
          a11y={true}
          autoHeight={false}
          initialSlide={0}
          slidesPerView={1}
          breakpoints={{
            480: {
              slidesPerView: 1,
              // spaceBetween: 20,
            },
            800: {
              slidesPerView: props.slidesshown[2] || 2,
              initialSlide: 0,
              // slidesPerGroup: props.slidesshown[2] || 2,
              // spaceBetween: 20,
            },
            1024: {
              slidesPerView: props.slidesshown[1] || 3,
              initialSlide: 0,
              // slidesPerGroup: props.slidesshown[1] || 3,
              // spaceBetween: 20,
            },
            1280: {
              slidesPerView: props.slidesshown[0] || 4,
              initialSlide: 0,
              // slidesPerGroup: props.slidesshown[1] || 3,
              // spaceBetween: 20,
            },
          }}
          className="orm-carslider-swiper"
        >
          {filteredVehicles.length === 0 ? (
            <p className="orm__empty">Keine Fahrzeuge gefunden.</p>
          ) : (
            filteredVehicles.map((v) => (
              <SwiperSlide key={v.id} className={`orm-vehicle-slide`}>
                <div className={`orm-vehicle-slide-inner`}>
                  {" "}
                  <div className="orm-vehicle-card__slider">
                    <div className="orm-vehicle-card__slider-coverImg">
                      <img src={sizeImg(v.images[0].image, 900)} alt={v.type} />
                    </div>
                  </div>
                  <div className="orm-vehicle-card__content orm-mt-16 orm-mb-32">
                    <h3 className="orm-headline__h2 text-center">
                      {props.usevehicles ? v.text_web : v.type}
                    </h3>
                  </div>
                  <div className="orm-vehicle-card__footer">
                    <button
                      className="orm-button__cta orm-btn__block"
                      onClick={() => setCar(v)}
                    >
                      {ORMfunctions.i18n("general/showOffers") ||
                        "Angebote zeigen"}
                    </button>
                  </div>
                </div>
              </SwiperSlide>
            ))
          )}
        </Swiper>
      </div>

      {showModal && (
        <SearchModal
          enabledstations={enabledstations}
          close={() => setShowModal(false)}
        />
      )}
    </div>
  );
}

export default Carcategoryslider;
